export interface IColumnType {
	Name: string;
	Type: string;
}

// Category ä¸ä¸ªæ ç­¾ç±»å«ï¼ç®åç±»å«ä¸åå±
export interface ICategory {
	ID: string;
	Name: string;
	OwnerBy: OwnerByEnum;
	Owner: string;
	Position: number;
	Labels?: { ID: string; Name: string }[];
}
export interface ILabelKey {
	CategoryID: string;
	ID: string;
}
// Label æ ç­¾
export interface ILabel extends ILabelKey {
	Name: string;
}
// å½ownerby ä¸ºEæ¶ï¼ownerå­æ®µåºå®çå¼
export const ownerElement = 'ele';

export enum OwnerByEnum {
	unknow = '',
	// ownerByUser å±äºç¨æ·çæ ç­¾ãåé,å æ°å­æ¯ä¾¿äºæåº
	ownerByUser = '1U',
	// ownerByDept å±äºé¨é¨çæ ç­¾ãåé
	ownerByDept = '2D',
	// ownerByEle å±äºå·¥ä½åç´ çæ ç­¾ãåé
	ownerByEle = '3E'
}
// ----------------node--------------
export enum NodeTypeEnum {
	unknow = '',
	NodeAnd = 'AND',
	NodeOr = 'OR',
	NodeCondition = 'CONDITION',
	NodePlain = 'PLAIN'
}

export interface INode {
	NodeType: NodeTypeEnum;
	Field?: string;
	Operate?: string;
	Value?: string;
	PlainText?: string;
	Children?: INode[];
}

// å·¥ä½åç´ æ ç­¾ä¿®æ¹åå²æ¥å¿
export interface IElementHisLog {
	Operate: string;
	CategoryName: string;
	LabelName: string;
	User: string;
}
export interface IElementHis {
	Day: Date;
	Logs: IElementHisLog[];
}

export interface ILabelHisItem {
	Version: number;
	WriteTime: Date;
}
export interface ILabelHisKey {
	CategoryID: string;
	ID: string;
	Version: number;
}
export interface ColumnsWithLetter {
	Letter: string; // é¦å­æ¯
	Columns: string[];
}
